/* Audio Radar product page add-on cross-sell card.
   Loaded with defer so it doesn't block initial render.
   Manages: cart-state watcher, Shop Pay visibility, +Add button sync. */
(function () {
  function extractNumericId(gid) {
    var m = String(gid).match(/(\d+)$/);
    return m ? m[1] : gid;
  }

  function updateShopPayVisibility(itemCount) {
    var paymentBtns = document.querySelectorAll('.shopify-payment-button, [data-shopify="payment-button"]');
    paymentBtns.forEach(function (el) {
      if (itemCount > 0) {
        el.style.display = 'none';
        el.setAttribute('data-cart-hidden', 'true');
      } else {
        el.style.display = '';
        el.removeAttribute('data-cart-hidden');
      }
    });
    document.querySelectorAll('[data-cart-checkout]').forEach(function (el) {
      el.style.display = itemCount > 0 ? '' : 'none';
    });
  }

  function syncAddOnButtons(cart) {
    var inCart = {};
    (cart.items || []).forEach(function (item) {
      inCart[String(item.variant_id)] = item.quantity;
    });
    document.querySelectorAll('[data-add-on-add]').forEach(function (btn) {
      if (btn.dataset.state === 'adding') return;
      var vid = extractNumericId(btn.dataset.variantId);
      if (inCart[vid]) {
        btn.dataset.state = 'added';
        btn.textContent = '✓ Added to cart';
      } else {
        btn.dataset.state = '';
        btn.textContent = '+ Add';
      }
    });
  }

  function checkCartAndUpdate() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' }, cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        updateShopPayVisibility(cart.item_count || 0);
        syncAddOnButtons(cart);
        try {
          document.dispatchEvent(new CustomEvent('audioradar:cart-updated', { detail: cart }));
        } catch (e) {}
        return cart;
      })
      .catch(function (err) { console.warn('[cart-watcher]', err); });
  }
  window.__audioRadarCartWatcher = checkCartAndUpdate;

  function hookThemeCartUpdates() {
    var tries = 0;
    function attach() {
      if (window.PXUTheme && window.PXUTheme.jsAjaxCart && typeof window.PXUTheme.jsAjaxCart.updateView === 'function') {
        var original = window.PXUTheme.jsAjaxCart.updateView;
        window.PXUTheme.jsAjaxCart.updateView = function () {
          var result = original.apply(this, arguments);
          setTimeout(checkCartAndUpdate, 200);
          return result;
        };
        return;
      }
      if (++tries < 25) setTimeout(attach, 200);
    }
    attach();
  }

  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'visible') checkCartAndUpdate();
  });

  document.addEventListener('audioradar:cart-updated', function (e) {
    if (!e.detail) return;
    updateShopPayVisibility(e.detail.item_count || 0);
    syncAddOnButtons(e.detail);
  });

  window.addEventListener('pageshow', function (e) {
    if (e.persisted) checkCartAndUpdate();
  });

  checkCartAndUpdate();
  hookThemeCartUpdates();

  var buttons = document.querySelectorAll('[data-add-on-add]');
  if (!buttons.length) return;

  function refreshThemeCart(cart) {
    try {
      if (window.PXUTheme && window.PXUTheme.jsAjaxCart && typeof window.PXUTheme.jsAjaxCart.updateView === 'function') {
        window.PXUTheme.jsAjaxCart.updateView();
      }
    } catch (e) {}

    if (cart && typeof cart.item_count === 'number') {
      document.querySelectorAll('[data-bind="itemCount"]').forEach(function (el) {
        el.textContent = cart.item_count;
      });
      document.querySelectorAll('[data-ajax-cart-trigger]').forEach(function (el) {
        if (cart.item_count > 0) el.classList.add('has-cart-count');
        else el.classList.remove('has-cart-count');
      });
    }
  }

  buttons.forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      if (btn.dataset.state === 'adding') return;
      var variantId = extractNumericId(btn.dataset.variantId);
      var originalLabel = btn.textContent;
      btn.dataset.state = 'adding';
      btn.textContent = 'Adding…';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
      })
        .then(function (res) {
          return res.json().then(function (data) {
            if (!res.ok) throw new Error((data && (data.description || data.message)) || ('HTTP ' + res.status));
            return data;
          });
        })
        .then(function () {
          return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); });
        })
        .then(function (cart) {
          refreshThemeCart(cart);
          updateShopPayVisibility(cart.item_count || 0);
          btn.dataset.state = 'added';
          btn.textContent = '✓ Added to cart';
        })
        .catch(function (err) {
          console.error('[add-ons] add failed:', err);
          btn.dataset.state = 'error';
          btn.textContent = 'Try again';
          setTimeout(function () {
            btn.dataset.state = '';
            btn.textContent = originalLabel;
          }, 2400);
        });
    });
  });
})();
